import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { TransportPage } from "./pages/TransportPage";
import { TourismPage } from "./pages/TourismPage";
import { AccommodationsPage } from "./pages/AccommodationsPage";
import { HospitalityPage } from "./pages/HospitalityPage";
import { NaturePage } from "./pages/NaturePage";
import { SportsPage } from "./pages/SportsPage";
import { ServicesPage } from "./pages/ServicesPage";
import { AssociationsPage } from "./pages/AssociationsPage";
import { AccessibilityPage } from "./pages/AccessibilityPage";
import { LibrariesPage } from "./pages/LibrariesPage";
import { CulturePage } from "./pages/CulturePage";
import { AboutPage } from "./pages/AboutPage";
import { BeachesPage } from "./pages/BeachesPage";
import { PublicServicesPage } from "./pages/PublicServicesPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/transport" element={<TransportPage />} />
            <Route path="/tourism" element={<TourismPage />} />
            <Route path="/accommodations" element={<AccommodationsPage />} />
            <Route path="/hospitality" element={<HospitalityPage />} />
            <Route path="/nature" element={<NaturePage />} />
            <Route path="/sports" element={<SportsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/associations" element={<AssociationsPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/libraries" element={<LibrariesPage />} />
            <Route path="/culture" element={<CulturePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/beaches" element={<BeachesPage />} />
            <Route path="/public-services" element={<PublicServicesPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
